var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"stuMainTitle"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$route.meta.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }